import { SquarePen, Check, Eye } from "lucide-react";
import styles from "./Ticket.module.css"
import { useState } from "react";

function Ticket({ thisTicket, setIsOpen, setIsOpenLook, setIsOpenEdit }) {

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.containerTitle}>
                    <h2 className={styles.title}>{`${thisTicket.codigo} - ${thisTicket.car.placa}`}</h2>
                    <p className={styles.oficina}> {thisTicket.oficina}</p>
                </div>
                <div className={styles.btn}>
                    {thisTicket.status === "Finalizado" ? "" : <Check size={20} onClick={() => setIsOpen(thisTicket)} />}
                    
                </div>
            </div>
            <div className={styles.infos}>
                <div className={styles.fieldInfos}>
                    <span>Status</span>
                    <div className={
                        thisTicket.status === "Pendente" ? styles.novo :
                            thisTicket.status === "Agendada" ? styles.agendada :
                                thisTicket.status === "Finalizado" ? styles.finalizado :
                                    styles.andamento
                    }>
                        {thisTicket.status}
                    </div>
                </div>
                <div className={styles.fieldInfos}>
                    <span>Custo</span>
                    <p>{`R$ ${thisTicket.custo}`}</p>
                </div>
                <div className={styles.fieldInfos}>
                    <span>Data Abertura</span>
                    <p>{thisTicket.dataAbertura}</p>
                </div>
                <div className={styles.fieldInfos}>
                    <span>Entrega Prevista</span>
                    <p>{thisTicket.dataPrevisao}</p>
                </div>
            </div>
            <div className={styles.descricao}>
                <span>Descrição</span>
                <p>{thisTicket.descricao}</p>
            </div>
            {thisTicket.status === "Finalizado" ? 
                <button className={styles.btnEdit} onClick={() => setIsOpenEdit(thisTicket)}><Eye size={16}/>Visualizar</button> 
                : 
                <button className={styles.btnEdit} onClick={() => setIsOpenEdit(thisTicket)}><SquarePen size={14}/>Editar</button>}
        </div>
    )
}

export default Ticket;